import { DeviceService } from '@/common/api.service'
import {
  FETCH_DEVICES,
  FETCH_DETECTION_DEVICES,
  FETCH_END,
  FETCH_START,
  SET_ERROR,
  SET_DETECTION_DEVICES,
  SET_DETECTION_BRAND,
  SET_DETECTION_STATE,
} from '../actions.type'
import utils from '@/utils'

export const state = {
  brands: {},
  devices: {},
  detectedOptions: {
    showed: false,
    devices: [],
    brand: null,
  },
  isLoading: true,
}

export const actions = {
  [FETCH_DEVICES](context) {
    context.commit(FETCH_START)
    return DeviceService.query()
      .then(({ data }) => {
        context.commit(FETCH_END, data)
      })
      .catch(error => {
        throw new Error(error)
      })
  },
  [FETCH_DETECTION_DEVICES](context, genericInstructionId) {
    var hardwareInfoObj = {
      w: window.screen.width || 0,
      h: window.screen.height || 0,
      r: ~~((window.devicePixelRatio || 1) * 100),
    }
    var hardwareInfoStr = Object.keys(hardwareInfoObj)
      .reduce(function(a, k) {
        a.push(encodeURIComponent(hardwareInfoObj[k]))
        return a
      }, [])
      .join(':')

      if (navigator.userAgentData) {
        navigator.userAgentData.getHighEntropyValues(['model']).then((ua) => {
          return DeviceService.getDetectionDevices({
            params: {
              _: new Date().getTime(),
              'api-key': '91a7d1c7-1059-47dc-b549-5af769fcb1a4',
              modelIdentifier: ua ? ua.model : '',
              hardwareInfo: hardwareInfoStr,
              version: 2,
            },
          }).then(({ data }) => {
            let devices = []
            if (data.Device != null) {
              devices.push(data.Device)
            } else if (data.AlternativeDevices != null) {
              devices = data.AlternativeDevices
            } else if (data.SuggestedManufacturer) {
              context.commit(SET_DETECTION_BRAND, data.SuggestedManufacturer)
            }
            if (devices.length) {
              devices.forEach((d) => {
                d.Id = utils.fixWmAdminDeviceId(d.Id)
              })
              context.commit(SET_DETECTION_DEVICES, devices)
            }
          })
        })
      } else {
        return DeviceService.getDetectionDevices({
          params: {
            _: new Date().getTime(),
            'api-key': '91a7d1c7-1059-47dc-b549-5af769fcb1a4',
            hardwareInfo: hardwareInfoStr,
            version: 2,
          },
        }).then(({ data }) => {
          let devices = []
          if (data.Device != null) {
            devices.push(data.Device)
          } else if (data.AlternativeDevices != null) {
            devices = data.AlternativeDevices
          } else if (data.SuggestedManufacturer) {
            context.commit(SET_DETECTION_BRAND, data.SuggestedManufacturer)
          }
          if (devices.length) {
            devices.forEach(d => {
              d.Id = utils.fixWmAdminDeviceId(d.Id)
            })
            context.commit(SET_DETECTION_DEVICES, devices)
          }
        })
      }    
  }
}

export const mutations = {
  [FETCH_START](state) {
    state.isLoading = true
  },
  [FETCH_END](state, { brands, devices }) {
    state.brands = brands
    state.devices = devices
    state.isLoading = false
  },
  [SET_ERROR](state, error) {
    state.errors = error
  },
  [SET_DETECTION_DEVICES](state, devices) {
    state.detectedOptions.devices = devices
  },
  [SET_DETECTION_BRAND](state, brand) {
    state.detectedOptions.brand = brand
  },
  [SET_DETECTION_STATE](state, value) {
    state.detectedOptions.showed = value
  },
}

const getters = {
  brands(state, getters, rootState, rootGetters) {
    const isPreview = rootGetters['settings/isPreview']
    if (isPreview) {
      return state.brands
    }
    return state.brands.filter(x => x.online)
  },
  devices(state, getters, rootState, rootGetters) {
    const isPreview = rootGetters['settings/isPreview']
    if (isPreview) {
      return state.devices
    }
    return state.devices.filter(x => x.online)
  },
  isLoading(state) {
    return state.isLoading
  },
  detectedOptions(state) {
    return state.detectedOptions
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
}
